import React from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import {
  useAppDispatch,
  useAuthState,
  useBusinessState,
  useModalState,
} from '@core/configureStore';
import { openModal } from '@core/features';
import { Button } from 'antd';
import { TbBriefcase } from 'react-icons/tb';
import { shortenString } from '@utils/string.util';

type Props = {
  redirect?: string;
};

const SelectBusinessButton = ({ redirect }: Props) => {
  const dispatch = useAppDispatch();
  const { user } = useAuthState();
  const { locationModal } = useModalState();
  const { locations } = useBusinessState();

  const openBusinessModal = () => {
    if (locations.length === 0) {
      dispatch(
        openModal({
          modalName: 'welcomeLocationModal',
          extraParams: {
            redirect: redirect,
          },
        })
      );
    } else {
      dispatch(
        openModal({
          modalName: 'locationModal',
          extraParams: {
            redirect: redirect,
          },
        })
      );
    }
  };

  return (
    <Button style={{ fontSize: 11 }} type="primary" onClick={openBusinessModal}>
      <TbBriefcase />{' '}
      <React.Fragment>
        {user?.selected_location
          ? `Business: ${shortenString(user.selected_location.title, 15)}`
          : 'Select Business'}{' '}
        &nbsp;
        {locationModal ? <DownOutlined /> : <RightOutlined />}
      </React.Fragment>
    </Button>
  );
};

export default SelectBusinessButton;
